import omit from 'lodash/omit';

import {
  DataSourceType,
  UNKNOWN_DATA_SOURCE_TYPE,
} from 'src/constants/dataSourceTypeDescription';
import { ProjectResourceType } from 'src/constants/project';
import { NodeCategory } from 'src/containers/ProjectDiagram/constants/categories';
import { Resource } from 'src/containers/ProjectDiagram/types/data';
import { ProjectResourceField } from 'src/store/state/projects';

export const getResourceKey = (value: string) =>
  `${NodeCategory.RESOURCE}-${value}`;

export const getResourceValue = (key: string) =>
  key.replace(new RegExp(`^${NodeCategory.RESOURCE}-`), '');

type BaseCreateResourceOptions = {
  fields: ProjectResourceField[];
  value: string;
  text?: string;
};

type CreateResourceOptions =
  | (BaseCreateResourceOptions & {
      type: ProjectResourceType.FILE_UPLOAD;
    })
  | (BaseCreateResourceOptions & {
      dataSourceType?: DataSourceType | null;
      type: ProjectResourceType.VIRTUAL_GRAPH;
    });

export const createResource = (args: CreateResourceOptions): Resource => ({
  ...args,
  key: getResourceKey(args.value),
  fields: args.fields.map((field) =>
    omit<ProjectResourceField, 'statistics'>(field, 'statistics')
  ),
  ...(args.type === ProjectResourceType.VIRTUAL_GRAPH
    ? {
        dataSourceType: args.dataSourceType || UNKNOWN_DATA_SOURCE_TYPE,
      }
    : {}),
  text: args.text || args.value,
  category: NodeCategory.RESOURCE,
});
